export default "__VITE_ASSET__0917fc78__"